import { BOOKING_SUMMARY_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  bookingSummaryReports: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const bookingSummaryReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case BOOKING_SUMMARY_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case BOOKING_SUMMARY_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        bookingSummaryReports: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case BOOKING_SUMMARY_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default bookingSummaryReportReducer;
